<div class="date-picker-container" [class.disabled]="disabled">
  <span class="input-title">
    {{ label }}<span *ngIf="required" class="asterisk">*</span>
    <span *ngIf="disabled" class="disabled-indicator">(Disabled)</span>
  </span>

  <mat-form-field [appearance]="appearance" class="custom-date-picker-field">
    <input
      matInput
      [matDatepicker]="picker"
      [formControl]="control"
      [placeholder]="placeholder"
      [required]="required"
      [disabled]="disabled"
      [min]="minDate"
      [max]="maxDate"
      (dateChange)="onDateChange($event)"
      (blur)="onTouched()">
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <mat-datepicker-toggle matIconPrefix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error>
  </mat-form-field>
</div>
